import { useEffect } from "react";
import { useLookupQuery } from "./hooks/useLookupQuery";
import { fetchTaxYears } from "./services/lookupService";
import { useTaxYearStore } from "./store/useTaxYear";

export const TaxYearInitializer = () => {
  const { data: taxYearOptions, isLoading } = useLookupQuery(
    "taxYears",
    fetchTaxYears,
    false
  );

  const selectedTaxYear = useTaxYearStore((s) => s.selectedTaxYear);
  const setSelectedTaxYear = useTaxYearStore((s) => s.setSelectedTaxYear);
  const isFirstLoginInCurrentMonth = useTaxYearStore(
    (s) => s.isFirstLoginInCurrentMonth
  );
  const markCurrentMonthInitialized = useTaxYearStore(
    (s) => s.markCurrentMonthInitialized
  );

  useEffect(() => {
    if (isLoading || !taxYearOptions?.length) return;

    const currentDate = new Date();
    const currentMonth = currentDate.getMonth(); // 0-indexed (0 = January)
    const currentYear =
      currentMonth <= 3
        ? currentDate.getFullYear() - 1
        : currentDate.getFullYear();
    const defaultTaxYear =
      taxYearOptions.find((y) => y.id === currentYear) ?? taxYearOptions[0];

    if (isFirstLoginInCurrentMonth()) {
      setSelectedTaxYear(defaultTaxYear.id);
      markCurrentMonthInitialized();
      return;
    }

    if (selectedTaxYear === undefined) {
      setSelectedTaxYear(defaultTaxYear.id);
    }
  }, [
    isLoading,
    taxYearOptions,
    selectedTaxYear,
    setSelectedTaxYear,
    isFirstLoginInCurrentMonth,
    markCurrentMonthInitialized,
  ]);

  return null; // It's just an initializer, nothing to render
};
